// Author Liang Gangqiang
// Date 2021-03-18 16:13:23

class SithMesQualityInspectTemplate {
constructor({
        id = null,
        parentId = '',
        childId = '',
        name = '',
        type = '',
        format = '',
        defaultValue = '',
        seq = '',
        remark = ''}
= {}) {
    this.id = id;
    this.parentId = parentId;
    this.childId = childId;
    this.name = name;
    this.type = type;
    this.format = format;
    this.defaultValue = defaultValue;
    this.seq = seq;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesQualityInspectTemplate();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'parentId',
        label: 'label.sith.quality.sithMesQualityInspectTemplate.grid.parentId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'childId',
        label: 'label.sith.quality.sithMesQualityInspectTemplate.grid.childId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.sith.quality.sithMesQualityInspectTemplate.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.sith.quality.sithMesQualityInspectTemplate.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'level',
        label: 'label.sith.quality.sithMesQualityInspectTemplate.grid.level',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.sith.quality.sithMesQualityInspectTemplate.grid.nodeCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityInspectTemplate.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    parentIdFilter : "",
    childIdFilter : "",
    nameFilter : "",
    typeFilter : "",
    formatFilter : "",
    defaultValueFilter : "",
    seqFilter : "",
    levelFilter : "",
    nodeCodeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.sith.quality.sithMesQualityInspectTemplate.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seqFilter',
        label: 'label.sith.quality.sithMesQualityInspectTemplate.filter.seq',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.sith.quality.sithMesQualityInspectTemplate.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityInspectTemplate.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesQualityInspectTemplate, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
